module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/WebbankirGirl-c2c94a7902bbed7cac4f9df4f209e11e.png";